/**
 * rubyParts.ts
 * Shared helpers to build RubyPart values.
 */
import type { RubyPart } from './types';

export const t = (text: string): RubyPart => ({ kind: 'text', text });
export const r = (base: string, ruby: string): RubyPart => ({ kind: 'ruby', base, ruby });

